module.exports = __webpack_public_path__ + "img/hr.9894f453.svg";